import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import TableCell from './TableCell';

const TableHeaderRow = ({ columnDefs, preview, className, variant = 'primary' }) => {
  const lastIdx = columnDefs.length - 1;
  const isPrimary = variant === 'primary';

  return (
    <tr
      className={cn(
        'h-8 border-0 border-b border-solid',
        isPrimary ? 'border-primary-200 bg-primary-25' : 'border-neutral-200 bg-white',
        className
      )}>
      {columnDefs.map((col, index) => (
        <TableCell
          key={String(col.field)}
          index={index}
          lastIdx={lastIdx}
          preview={preview}
          className={cn('px-2 py-1.5 align-bottom', col?.cellClass)}>
          <Typography variant="p" size="small" weight="semibold" color="neutral-800">
            {col.headerName}
          </Typography>
        </TableCell>
      ))}
    </tr>
  );
};

export default TableHeaderRow;
